import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "toolbar",
  id: "kt_toolbar"
}
const _hoisted_2 = {
  "data-kt-swapper": "true",
  "data-kt-swapper-mode": "prepend",
  "data-kt-swapper-parent": "{default: '#kt_content_container', 'lg': '#kt_toolbar_container'}",
  class: "page-title me-3"
}
const _hoisted_3 = { class: "text-dark fw-bolder fs-1 my-1" }
const _hoisted_4 = { class: "breadcrumb breadcrumb-dot fw-bold my-1" }
const _hoisted_5 = {
  key: 1,
  class: "text-primary text-hover-primary"
}
const _hoisted_6 = {
  key: 0,
  class: "d-flex align-items-center justify-content-end w-100 w-lg-auto"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "las la-sync fs-1 text-primary" }, null, -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "m-0 me-10" }
const _hoisted_10 = {
  key: 1,
  class: "d-flex align-items-center justify-content-end w-100 w-lg-auto"
}
const _hoisted_11 = {
  class: "btn btn-outline btn-outline-primary btn-active-light-primary mb-1 me-10",
  id: "kt_lookup_drawer_toggle-activity"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_DateRange = _resolveComponent("DateRange")!

  return (!_ctx.isHomeLayout)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          id: "kt_toolbar_container",
          class: _normalizeClass([{
        'container-fluid': _ctx.toolbarWidthFluid,
        'container-xxl': !_ctx.toolbarWidthFluid,
      }, "d-flex flex-stack ps-13"])
        }, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.title == "Sites" ? "Branches" : _ctx.title), 1),
              _createElementVNode("ul", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.breadcrumbs, (singleCrumb, i) => {
                  return (_openBlock(), _createElementBlock("li", {
                    class: "breadcrumb-item text-muted",
                    key: singleCrumb
                  }, [
                    (i == 0)
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 0,
                          to: "/dashboard",
                          class: "text-muted text-hover-primary"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(singleCrumb), 1)
                          ]),
                          _: 2
                        }, 1024))
                      : (_openBlock(), _createElementBlock("a", _hoisted_5, _toDisplayString(singleCrumb == "Sites" ? "Branches" : singleCrumb), 1))
                  ]))
                }), 128))
              ])
            ])
          ]),
          (_ctx.isDateRangeComponent)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("button", {
                  onClick: _cache[0] || (_cache[0] = _withModifiers(() => _ctx.emitter?.emit('refreshDashboard', true), ["prevent"])),
                  type: "button",
                  class: "btn bg-transparent position-relative d-block"
                }, _hoisted_8),
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_DateRange)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isActivityComponent)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.t("common.activity")), 1)
              ]))
            : _createCommentVNode("", true)
        ], 2)
      ]))
    : _createCommentVNode("", true)
}